import { render, staticRenderFns } from "./cartPanel.vue?vue&type=template&id=440e43d1&"
import script from "./cartPanel.vue?vue&type=script&lang=js&"
export * from "./cartPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports